import { useEffect, useState } from "react";
import { HOME_DEFAULT, SmartLink } from "@/lib/content";

const POOL = "dbs_fb01-001 dbs_fb03-001 dbs_vegeta lor_elsa lor_maleficent lor_mickey lor_moana lor_stitch magic_counterspell magic_lightningbolt magic_lotus magic_ragavan magic_ring magic_sheoldred magic_solring op_cm_690958 op_shanks_alt_cm op_shanks_cm pkm_279646 pkm_316016 pkm_360923 pkm_690593 pkm_907630 pkm_907635 pkm_907641 pkm_907646 pkm_907647 rift_0 rift_1 rift_p0 rift_p1 rift_p2 ygo_ash ygo_blue-eyes ygo_dark ygo_exodia ygo_red-eyes".split(" ");
const SLOTS = [
  [1, 10, -9, true], [9, 55, 7], [15, 6, -4, true], [22, 50, 10, true], [29, 14, -7], [35, 58, 5], [41, 4, -11, true], [47, 46, 8],
  [53, 12, 4], [59, 56, -6, true], [65, 6, 9], [71, 48, -8], [77, 14, 6, true], [83, 58, -5], [89, 8, 10], [94, 52, -7, true],
];
const START = SLOTS.map((_, i) => POOL[(i * 7) % POOL.length]);
const W = "w-[clamp(46px,5.2vw,96px)] aspect-[5/7]";
const pos = (l, t, r, extra = "") => ({ left: `${l}%`, top: `${t}%`, transform: `rotate(${r}deg) ${extra}` });
const SWAP_MS = 2200;

const useRotatingCards = () => {
  const [cards, setCards] = useState(START);
  useEffect(() => {
    POOL.forEach((n) => { new Image().src = `/cards/${n}.webp`; });
    const id = setInterval(() => {
      setCards((cur) => {
        const free = POOL.filter((n) => !cur.includes(n));
        const slot = Math.floor(Math.random() * cur.length);
        const next = [...cur];
        next[slot] = free[Math.floor(Math.random() * free.length)];
        return next;
      });
    }, SWAP_MS);
    return () => clearInterval(id);
  }, []);
  return cards;
};

export const HeroCards = ({ home = HOME_DEFAULT }) => {
  const cards = useRotatingCards();
  return (
    <>
      <section className="relative h-[220px] overflow-hidden sm:h-[280px] md:h-[320px]" data-testid="hero-section">
        <div className="absolute inset-0 scale-110 bg-cover bg-center blur-md brightness-90" style={{ backgroundImage: `url(${home.hero_image || "/brand/logo-shop.jpg"})` }} aria-hidden role="img" aria-label="Carte collezionabili Card Source" data-testid="hero-bg" />
        {SLOTS.map(([l, t, r, m], i) => (
          <span key={`s-${i}`} aria-hidden className={`hero-shadow-in absolute rounded-[6%] bg-[#404040] mix-blend-multiply blur-[12px] ${W} ${m ? "" : "hidden md:block"}`}
            style={{ ...pos(l, t, r, "translate(9%, 7%)"), animationDelay: `${250 + i * 70}ms` }} />
        ))}
        {SLOTS.map(([l, t, r, m], i) => (
          <div key={i} className={`absolute ${W} ${m ? "" : "hidden md:block"}`} style={pos(l, t, r)} data-testid={`hero-card-${i}`}>
            <img key={cards[i]} src={`/cards/${cards[i]}.webp`} alt="" data-card={cards[i]}
              className="hero-card-in block h-full w-full rounded-[5%] object-cover" style={{ animationDelay: cards[i] === START[i] ? `${150 + i * 70}ms` : "0ms" }} />
          </div>
        ))}
      </section>
      <div className="border-b-2 border-black bg-amber-500 px-4 py-3 text-center" data-testid="hero-cta-band">
        <h1 className="font-display font-strong mx-auto text-sm text-black xl:whitespace-nowrap md:text-base" data-testid="hero-cta-text">{home.hero_text}</h1>
        <div className="mt-2.5 flex flex-wrap justify-center gap-3">
          {home.cta1_label && <SmartLink to={home.cta1_link} data-testid="hero-shop-button" className="sticker-btn rounded-full bg-black px-6 py-2 font-display text-sm text-white">{home.cta1_label}</SmartLink>}
          {home.cta2_label && <SmartLink to={home.cta2_link} data-testid="hero-sealed-button" className="sticker-btn rounded-full bg-white px-6 py-2 font-display text-sm text-black">{home.cta2_label}</SmartLink>}
        </div>
      </div>
    </>
  );
};
